import React, { createContext, useContext, useState, ReactNode } from 'react'

type AuthStep = 'email' | 'enter_password' | 'create_password' | 'forgot_password' | 'create_new_password' | 'email_sent'

interface AuthModalContextType {
  opened: boolean
  step: AuthStep
  openAuthModal: (step?: AuthStep) => void
  closeAuthModal: () => void
}

const AuthModalContext = createContext<AuthModalContextType | undefined>(undefined)

export const AuthModalProvider = ({ children }: { children: ReactNode }) => {
  const [opened, setOpened] = useState(false)
  const [step, setStep] = useState<AuthStep>('email')

  const openAuthModal = (newStep: AuthStep = 'email') => {
    setStep(newStep)
    setOpened(true)
  }

  const closeAuthModal = () => {
    setOpened(false)
  }

  return <AuthModalContext.Provider value={{ opened, step, openAuthModal, closeAuthModal }}>{children}</AuthModalContext.Provider>
}

export const useAuthModal = () => {
  const context = useContext(AuthModalContext)
  if (!context) {
    throw new Error('useAuthModal must be used within an AuthModalProvider')
  }
  return context
}
